export const EXACT_LENGTH_ERROR = 'Field must contain {length} characters'
export const EXACT_LENGTHS_ERROR = 'Field must contain either {length1} or {length2} characters'
export const MAX_LENGTH_ERROR = 'Field must contain at most {length} characters'
export const MIN_LENGTH_ERROR = 'Field must contain at least {length} characters'
export const REQUIRED_ERROR = 'Field is required'
export const MATCH_REGEX_ERROR = 'Field must match the following regex {regex}'
